import { gql } from "@apollo/client";

export const getSegments = gql`
    query ($queryParams: QueryParams!) {
        getSegments(queryParams: $queryParams) {
            total
            items {
                id
                friendlyId
                name
                description
                count
                type
                createdAt
                createdBy
                updatedAt
                updatedBy
                stats
                isHidden
            }
        }
    }
`;

export const getSegmentsPaginated = gql`
    query ($queryParams: QueryParams!) {
        getSegmentsPaginated(queryParams: $queryParams) {
            hasMore
            items {
                id
                friendlyId
                name
                description
                count
                type
                createdAt
                createdBy
                updatedAt
                updatedBy
                stats
                isHidden
            }
        }
    }
`;

export const getSegmentsAgents = gql`
    query getSegmentsAgents {
        getSegmentsAgents {
            updatedByNames
            createdByNames
        }
    }
`;

export const getSegmentById = gql`
    query ($id: String!) {
        getSegment(id: $id) {
            id
            friendlyId
            joinType
            name
            description
            count
            type
            conditions
            dynamicConditions
            filePath
            updateOnlyExisting
            triggerJourney
            journeysToTrigger
            stats
            isHidden
        }
    }
`;
